import { AuthService } from './../services/auth.service';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { LOGIN_ENDPOINT } from '../config/config.constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HandleErrorInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // NON intercettare chiamate UControl API: un 401 dal Bridge (token Keycloak scaduto/rifiutato)
        // non deve disconnettere l'utente dal portale Agri_FE
        if (req.url.includes(environment.ucontrol?.apiUrl || 'uc-diaglight.dts1.actiafleet.com')) {
            return next.handle(req);
        }
        return next.handle(req).pipe(catchError(x=> this.handleAuthError(x, req)));
    }
    private handleAuthError(err: HttpErrorResponse, req: HttpRequest<any>): Observable<any> {
        // Sul login un 401 significa "credenziali errate", non "sessione scaduta":
        // niente logout automatico, l'errore deve arrivare intatto al login.component.
        if (err.status === 401 && !req.url.includes(LOGIN_ENDPOINT)) {
            this.authService.sessionExpired();
        }
        return throwError(() => err);
    }
}
